const key = `TEMPLATES`

export const TEMPLATES = {
    CLEAR: `${key}_CLEAR`,
    SET_TEMPLATE_LIST_LOADING:`${key}_SET_TEMPLATE_LIST_LOADING`,
    SET_TEMPLATE_LIST:`${key}_SET_TEMPLATE_LIST`,
};